import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { Rules } from "../../s25-rule-tree/s25.rule.const";
import { ModalData } from "../modal.service";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-rule [rule]="data.rule" (saved)="closeAndRefresh()" (canceled)="closeModal()"></s25-ng-rule>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEditRuleComponent implements OnInit {
    @Input() data: ModalData & { rule: Rules.Rule; refresh: () => void; isNew?: boolean };
    isInit: boolean = false;

    ngOnInit() {
        this.isInit = true;
    }

    closeModal() {
        this.data.closeModal();
    }

    closeAndRefresh() {
        this.closeModal();
        this.data.refresh();
    }
}
